// @ts-nocheck
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackPageViewParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/trackPageView";
import { RecursivePartial } from "@toolkit/Framework/Types/Common";

const baseGA = { ...ga };

Object.assign<Toolkit.GoogleAnalytics, RecursivePartial<Toolkit.GoogleAnalytics>>(ga, {
    /*
    track: {
        ...ga.track,
        pageView: (parameters: TrackPageViewParameters = {}, options?: Toolkit.GoogleAnalytics.Options) => {
            return baseGA.track.pageView(
                {
                    sample_prop: "sample_data",
                    ...parameters,
                },
                options,
            );
        },
    },
    */
});
